import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import FormBuilder from '../helpers/form-builder';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import initialState from '../helpers/form-helpers/initial-state';
import { formConstants } from '../../utils/constants/form-constants';
import SSOCloseButton from '../../common/utility/SSOCloseButton';
import { deepCopyObject } from '../../utils/obj-utils';

class UpdateAddressForm extends Component {
    constructor(props) {
        super(props);

        this.state = initialState.updateUserAddressesFormState;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.displayUpdateAddressForm = this.displayUpdateAddressForm.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {
            loading,
            formData,
            retrievedUserAddress,
            isUserAddressRetrieveSuccessful
        } = nextProps;

        if (!loading && isUserAddressRetrieveSuccessful) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
        }
    }

    componentDidMount() {
        const { formData } = this.props;
        this.setState(formStateHelpers.updateFormFields(formData));
    }

    displayUpdateAddressForm() {
        const { actions, formData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, state } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];
        copyOfFormData[formConstants.mainAddress].defaultValue = this.state[formConstants.mainAddress];
        copyOfFormData[formConstants.billingAddress].defaultValue = this.state[formConstants.billingAddress];
        copyOfFormData[formConstants.shippingAddress].defaultValue = this.state[formConstants.shippingAddress];


        return FormBuilder({
            formData: copyOfFormData,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),
                    () => {
                        actions.resetRetrievedUserAddress();
                    });
            },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitAddressData);
    }

    submitAddressData() {
        const { onUpdateAddressClick } = this.props;
        onUpdateAddressClick({ updatedAddress: this.getAddressForUpdate() });
    }

    getAddressForUpdate() {
        const addressForUpdate = {};
        addressForUpdate[formConstants.addressLine1] = this.state[formConstants.addressLine1];
        addressForUpdate[formConstants.addressLine2] = this.state[formConstants.addressLine2];
        addressForUpdate[formConstants.addressLine3] = this.state[formConstants.addressLine3];
        addressForUpdate[formConstants.postcode] = this.state[formConstants.postcode];
        addressForUpdate[formConstants.city] = this.state[formConstants.city];
        addressForUpdate[formConstants.country] = this.state[formConstants.country];
        addressForUpdate[formConstants.county] = this.state[formConstants.county];
        addressForUpdate[formConstants.state] = this.state[formConstants.state];
        addressForUpdate[formConstants.main] = this.state[formConstants.mainAddress];
        addressForUpdate[formConstants.shippingAddress] = this.state[formConstants.shippingAddress];
        addressForUpdate[formConstants.billingAddress] = this.state[formConstants.billingAddress];

        return addressForUpdate;
    }

    render() {
        const { onCloseUpdateAddressFormClick } = this.props;
        return (
            <div className='form-popup form-container'>
                <section className='form-popup__content'>
                    <SSOCloseButton onCloseButtonClick={onCloseUpdateAddressFormClick}></SSOCloseButton>
                    <form onSubmit={this.handleSubmit}>
                        {this.displayUpdateAddressForm()}
                        <SSOFormFooter
                            onSubmit={this.handleSubmit}
                            footerButtonText={formMessageConstants.saveAddress}>
                        </SSOFormFooter>
                    </form>
                </section>
            </div>
        );
    }
}

UpdateAddressForm.propTypes = {
    formData: PropTypes.object.isRequired,
    onUpdateAddressClick: PropTypes.func.isRequired,
    onCloseUpdateAddressFormClick: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateAddressForm);
